import React from 'react';
import styled from 'styled-components';
import {
  isSuspended,
  yellowCardCount,
  suspendedCopy,
  yellowCardsCopy,
  SENT_OFF_COPY,
} from '../../service/availability';
import { CAPTAIN_AUTO_COPY } from '../../service/captain';

// `compact` is the pitch card: icons only, stacked in the card's top-right
// corner under the injury icon. Lists get short words instead.
const Markers = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 4px;
  vertical-align: middle;
  &[data-compact='true'] {
    position: absolute;
    top: 22px;
    right: 2px;
    z-index: 2;
    margin: 0;
    flex-direction: column;
    align-items: flex-end;
  }
`;

const Marker = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 10px;
  height: 14px;
  padding: 0 3px;
  border-radius: 2px;
  font: 700 9px/1 Archivo, sans-serif;
  white-space: nowrap;
  &[data-kind='yellow'] {
    background: #f5c518;
    color: #211a00;
  }
  &[data-kind='red'] {
    background: #de3e32;
    color: #fff;
  }
  &[data-kind='captain'] {
    width: 14px;
    padding: 0;
    border-radius: 50%;
    background: #10231b;
    color: #fdca40;
  }
  &[data-kind='auto'] {
    background: #e3eee5;
    color: #10231b;
  }
`;

// Renders nothing for a player without ME 2.5 states, so rows and pitch cards
// look exactly as before while the API doesn't send the fields.
// `captain` is the captain block when this player is the captain, else null.
export default function PlayerStatusMarkers({ player, sentOff = false, captain = null, compact = false }) {
  const yellows = yellowCardCount(player);
  const suspended = isSuspended(player);
  if (!captain && !sentOff && !suspended && !yellows) return null;
  return (
    <Markers data-compact={compact}>
      {captain && (
        <Marker data-kind="captain" role="img" aria-label="Captain" title={captain.auto ? `Captain (Auto). ${CAPTAIN_AUTO_COPY}` : 'Captain'}>
          C
        </Marker>
      )}
      {captain?.auto && (
        <Marker data-kind="auto" title={CAPTAIN_AUTO_COPY}>Auto</Marker>
      )}
      {sentOff && (
        <Marker data-kind="red" role="img" aria-label={SENT_OFF_COPY} title={SENT_OFF_COPY}>
          {compact ? '' : 'Sent off'}
        </Marker>
      )}
      {suspended && (
        <Marker data-kind="red" role="img" aria-label={suspendedCopy(player)} title={suspendedCopy(player)}>
          {compact ? 'SUS' : 'Suspended'}
        </Marker>
      )}
      {yellows > 0 && (
        <Marker data-kind="yellow" role="img" aria-label={yellowCardsCopy(yellows)} title={yellowCardsCopy(yellows)}>
          {yellows}
        </Marker>
      )}
    </Markers>
  );
}
